// IMPORTS
// Modules
import { Link } from 'react-router-dom';


// COMPONENT
export default function Result (props) {
   // Component
   return (
      <div className='oneport-customquery-result'>
         <div className='oneport-customquery-result-links'>
            <button className='ohsbtn-success'><Link to={`/oneport/device?id=${props.content.device_id.value}`}>Navigate to Device</Link></button>
         </div>
         <div className='oneport-customquery-result-fields'>
            {props.parent.fields && props.parent.fields.length > 0 && props.parent.fields.map(function (field, i) {
               return (
                  <div key={`oneport-customquery-result-fields-field-${i}`} className='oneport-customquery-result-fields-field'>
                     <div className='oneport-customquery-result-fields-field-name'>
                        <p>{field.name}</p>
                     </div>
                     <div className='oneport-customquery-result-fields-field-value'>
                        <p>{props.content[field.id].value}</p>
                     </div>
                  </div>
               );
            })}
         </div>
      </div>
   );
}